module.exports = "/_next/static/images/viber_footer-e6e66c7ec01a48b645d00b7b831bbf07.png";